var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-title"},[_c('Logo',{staticClass:"page-title__logo"}),_c('h1',{staticClass:"page-title__text"},[_vm._v("Leonardo Braga")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }